import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { updateExperimentalConfig } from '@polyai/stream/store/reducers/experimental-config/actions';
import type {
  ExperimentalConfig,
  ExperimentalConfigs,
} from '@polyai/stream/store/reducers/experimental-config/types';

import { assignMetadata } from '../../utils/assign-metadata';

const experimentalConfigAdapter = createEntityAdapter<ExperimentalConfig>();
const experimentalConfigSelectors = experimentalConfigAdapter.getSelectors();

const initialState = {
  experimentalConfigs: experimentalConfigAdapter.getInitialState(),
} satisfies ExperimentalConfigs;

const slice = createSlice({
  name: 'experimentalConfig',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateExperimentalConfig, (state, action) => {
      const existingConfig = experimentalConfigSelectors.selectById(
        state.experimentalConfigs,
        action.payload.id,
      );

      const config: ExperimentalConfig = {
        ...action.payload,
        features: action.payload.features || {},
        active: true,
        createdAt: existingConfig?.createdAt || '',
        createdBy: existingConfig?.createdBy || '',
        updatedAt: '',
        updatedBy: '',
      };

      assignMetadata(action, config);
      experimentalConfigAdapter.upsertOne(state.experimentalConfigs, config);
    });
  },
});

export { experimentalConfigAdapter, experimentalConfigSelectors };

export {
  selectExperimentalConfig,
  selectExperimentalConfigByIds,
} from './selectors';
export default slice.reducer;
